<template>

    <div>
        <v-sheet width="300" color="transparent" v-if="!disableEdit">
            <!-- EDITABLE VIEW -->
            <v-tooltip top color="primary" open-delay="1000">
                <template v-slot:activator="{ on }">
                    <v-sheet
                        @click.stop="dialog=true"
                        v-on="on"
                        rounded
                        class="pa-3 body-1 cursor-pointer truncate"
                        :style="textFieldModel ? 'color: white;' : 'color: #BBB;'"
                        elevation="2"
                        height="48"
                        v-ripple
                        :color="color">
                        <div v-if="textFieldModel">
                            {{ textFieldModel }} <span v-if="debug" class="caption grey--text text--lighten-1">{{value.uuid}}</span>
                        </div>
                        <div v-else>
                            Select variable
                        </div>
                    </v-sheet>
                </template>
                <div v-if="textFieldModel">Data variable {{ textFieldModel }} ({{ ucFirst(value.type) }}). Click to
                    change.
                </div>
                <div v-else>Click to select data variable</div>
            </v-tooltip>

            <data-variable-picker v-if="!disableEdit"
                                  v-model="dialog"
                                  :selected="selectedVariables"
                                  :data-variables="dataVariables"
                                  @close="dialog=false"
                                  @change="variableSelected"
            ></data-variable-picker>
        </v-sheet>

        <!-- NON EDITABLE VIEW -->
        <div v-if="disableEdit">

            <data-variable-chip v-if="value"
                                :type="value.type"
                                :text="value.name"
                                :dark="true"
            ></data-variable-chip>

        </div>
    </div>

</template>

<script>

import DataVariablePicker from '../../../components/UI/DataVariablePicker';
import DataVariableChip from "../../../components/UI/DataVariableChip";

export default {

    components: {
        DataVariablePicker,
        DataVariableChip
    },

    props: {
        value: {
            required: false,
            type: Object,
            default: null,
        },
        dataVariables: {
            required: true,
            type: Array
        },
        disableEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        color: {
            type: String,
            required: true,
        },
    },
    watch: {
        value(value) {
            if (value) {
                this.textFieldModel = value.name;
                this.selectedVariables = [value];
            }
        },
    },

    mounted() {
        if (this.value) {
            this.textFieldModel = this.value.name;
            this.selectedVariables = [this.value];
        } else {
            // Open data variable picker dialog automatically
            this.dialog = true;
        }
    },

    data() {
        return {
            debug: false,
            textFieldModel: null,
            dialog: false,
            selectedVariables: [],
        }
    },

    methods: {
        variableSelected(variables) {
            this.selectedVariables = [variables[0]];
            this.$emit('input', variables[0]);
        }
    },

}
</script>

<style scoped>

.truncate {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
